import { useState, useEffect } from 'react';
import mitt from 'mitt';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

var scrollEmitter = mitt();
var SCROLL_EVENT = "scroll";
var SCROLL_TO_EVENT = "scrollTo";
/**
 * eventManager - A manager for toggling an event on and off.
 * @see https://github.com/developit/mitt for more emitter API details.
 *
 * @example
 * // Define an event handler.
 * const onScroll = eventManager("scroll");
 *
 * // Pass the event handler a callback to handle the expected data stream.
 * // The event handler, when invoked, returns an optional handler to remove the event.
 * // Typically the event removal should happen in componentWillUnmount.
 * const scrollDepth = ({scrollDepth}) => console.log(`Current scroll depth - ${scrollDepth}`));
 * const removeOnScrollListener = onScroll(scrollDepth);
 *
 * // Cleanup the event listener when is it no longer needed.
 * removerOnScrollListener();
 */

var eventManager = function eventManager(event) {
  return function (cb) {
    scrollEmitter.on(event, cb);
    return function () {
      return scrollEmitter.off(event, cb);
    };
  };
};
/**
 * emitOnScroll - publishes the scrolling event for subscribers to listen to.
 */


var emitOnScroll = function emitOnScroll(scrollDepth) {
  scrollEmitter.emit(SCROLL_EVENT, {
    scrollDepth: scrollDepth
  });
};
/**
 * onScroll - subscribes to the scroll event.
 */


var onScroll = eventManager(SCROLL_EVENT);
/**
 * emitOnScrollTo - publishes the scrollTo event for subscribers to listen to.
 */

var emitScrollTo = function emitScrollTo(targetPosition, scrollRate) {
  scrollEmitter.emit(SCROLL_TO_EVENT, {
    targetPosition: targetPosition,
    scrollRate: scrollRate
  });
};
/**
 * onScrollTo - subscribes to the scrollTo event.
 */


var onScrollTo = eventManager(SCROLL_TO_EVENT);
/**
 * useScrollTo hook.
 */

var useOnScroll = function useOnScroll() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      depth = _useState2[0],
      setDepth = _useState2[1];

  useEffect(function () {
    var removeScrollListener = onScroll(function (_ref) {
      var scrollDepth = _ref.scrollDepth;
      return setDepth(scrollDepth);
    });
    return function cleanup() {
      removeScrollListener();
    };
  }, []);
  return depth;
};

export { SCROLL_EVENT, SCROLL_TO_EVENT, emitOnScroll, emitScrollTo, eventManager, onScroll, onScrollTo, scrollEmitter, useOnScroll };
//# sourceMappingURL=scroll-emitter-esm.js.map
